import React, { FC } from 'react';
import { Icon } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { BodyTextMedium, HeadingText40 } from '@modernhealth/vital-components';

import { Modal as OldModal } from 'src/shared/components/Modal';
import { color } from 'src/shared/styles/variables';

type Props = {
    isVisible: boolean;
};

export const LoadingModal: FC<Props> = ({ isVisible }) => {
    const { t } = useTranslation();

    return (
        <StyledModal
            visible={isVisible}
            width={577.5}
            footer={null}
            closable={false}
            maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }} // the same that is in payments iframe
            transitionName="fade"
            maskTransitionName="fade"
        >
            <ContentContainer>
                <Icon
                    type="loading"
                    spin
                    css={{ strokeWidth: 50, color: color.casper, fontSize: 50 }}
                />
                <HeadingText40 marginTop={32}>{t('payments:loading_modal.title')}</HeadingText40>

                <BodyTextMedium centered>{t('payments:loading_modal.description')}</BodyTextMedium>
            </ContentContainer>
        </StyledModal>
    );
};

const StyledModal = styled(OldModal)({
    top: 64,

    '& .ant-modal-content': {
        borderRadius: 0,
        height: 390,

        '& .ant-modal-body': {
            padding: 0,
            height: '100%',
        },
    },
});

const ContentContainer = styled('div')({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
});
